import './App.css';
import Header from './components/Header';
import Offers from './components/Offers';
import Home from './components/Home';
import Deal from './components/Deal'
import Footer from './components/Footer'
import Checkout from './components/Checkout'
import { BrowserRouter as Router,Switch,Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/checkout">
          <Header/>
          <Checkout/>
        </Route>
        <Route path="/">
            <div className="app">
              <Header/>
              <Home/>
              <Offers/>
              <Deal/>
              <Footer/>
            </div>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
